import React from "react";
import { withRouter, Redirect } from "react-router";
import data from "./themeData/data.json";

const Home = () => {
		return <Redirect to={"/content/" + data.categories[0].id} />
};

export default withRouter(Home);
